import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

@NgModule({
  imports: [TranslateModule.forRoot()],
  providers: [provideTranslateHttpLoader()],
  exports: [TranslateModule],
})
export class CustomTranslateModule {}
